export enum HerdCells {
  /** Above 300 000 cells */
  Above = 'above',
  /** Below 300 000 cells */
  Below = 'below',
}

export enum HerdMilking {
  /** Conventional milking system */
  Conventional = 'conventional',
  /** Robotic milking system */
  Robot = 'robot',
}

export enum HerdBacteria {
  /** Mostly cow based bacteria (e.g. Staf aureus, Strep agalactiae) */
  Cow = 'cow',
  /** Mostly environmental (e.g Strep uberis, E coli) */
  Environmental = 'environmental',
  /** Unknown type of bacteria */
  Unknown = 'unknown',
}
